<template>
<div class="chapter">
<div class="inner_page">
<h1>Πίνακας Περιεχομένων</h1>
<p><a href="#/c001">Παιδικό βιβλίο με φωτογραφίες για τη γλώσσα του σώματος των σκύλων</a></p>
<p><a href="#/c002">Περιεχόμενα</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?a3eb5202